import React from "react";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface DelegateButtonProps {
  langBase: string;
  permission: string;
  isActionAvailable: boolean;
  onDelegate: () => void;
}

const DelegateButton: React.FC<DelegateButtonProps> = ({
  langBase,
  permission,
  isActionAvailable,
  onDelegate,
}) => {
  return (
    <FlowActionButton
      langBase={langBase}
      permission={permission}
      isActionAvailable={isActionAvailable}
      labelKey="delegate-button"
      testId="delegate"
      variant="outlined"
      startIcon={<AutorenewIcon />}
      onClick={onDelegate}
    />
  );
};
export default DelegateButton;
